import React from 'react';

const DownloadButton = ({ groupType, buttonType, color }) => {
    return (
        <div className={`download-button-group ${groupType}`}>
            <a href="https://www.amazon.com/Red-maca-Root-Powder-Supplement/dp/B07D18NF6Y" className={`download-button download-button-google ${buttonType}`}>
                <div className={`download-button-inner ${color}`}>
                    <div className={`download-button-icon c-green ${color}`}>
                        <i className="fab fa-amazon"></i>
                    </div>
                    <div className="download-button-content">
                        <h5 className={`c-grey upper ls-1 ${color}`}>Buy on</h5>
                        <h3 className={`c-dark ls-2 ${color}`}>amazon.com</h3>
                    </div>
                </div>
            </a>
            <a href="https://www.amazon.com/Red-maca-Root-Powder-Supplement/dp/B07D18NF6Y/ref=pd_ci_mcx_mh_mcx_views_0_title?pd_rd_w=DYUep&content-id=amzn1.sym.bb21fc54-1dd8-448e-92bb-2ddce187f4ac%3Aamzn1.symc.40e6a10e-cbc4-4fa5-81e3-4435ff64d03b&pf_rd_p=bb21fc54-1dd8-448e-92bb-2ddce187f4ac&pf_rd_r=R16893SNRPZX3YRV1QSW&pd_rd_wg=AmNNI&pd_rd_r=b11a16b9-fa7b-4317-a205-25a3ccc04a78&pd_rd_i=B07D18NF6#averageCustomerReviewsAnchor" className={`download-button download-button-apple ${buttonType}`}>
                <div className={`download-button-inner ${color}`}>
                    <div className={`download-button-icon c-blue ${color}`}>
                        <i className="fab fa-amazon"></i>
                    </div>
                    <div className="download-button-content">
                        <h5 className={`c-grey upper ls-1 ${color}`}>See Reviews on</h5>
                        <h3 className={`c-dark ls-2 ${color}`}>amazon.com</h3>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default DownloadButton;
